import { useCallback } from 'react';

import { DRAFT_STATUS_KEY } from '@redux/actions/cpSaleOrderStatuses/configs';

export const useCheckCTASOCart = () => {
  return useCallback((cartStatus) => {
    return cartStatus || cartStatus === 0 ? cartStatus !== DRAFT_STATUS_KEY : false;
  }, []);
};
